export default "/shell-coin-darken-logo.fc473b198ad942073c850b28fa4e8aa5.svg";